<template>
     <div  style="width: 100%;height: 55px;display: flex;align-items: flex-start;justify-content: space-between;" class="box11">
        <div class="box_left" >
            <!-- <img v-if="timetype" src="../assets/images/33.png" @click="timechang" class="img"/> -->
            <!-- <img v-else src="../assets/images/12.png" @click="timechang" class="img"/> -->
            <img src="../assets/images/48.png" @click="left" class="img1" />
        </div>
        <div class="box1">
            <div :style="{marginLeft:-lefttt+'px'}"  style="display: flex;transition: 1s;">
                <div class="box1_cent" v-for="(item,eindex) in arealist" @click="indexchange(eindex)">
                <div class="box1_cent_tt1" :class="eindex==index?'sty':''"></div>
                <div class="box1_cent_tt text-cut1" :style="eindex==index?'color: #0066d9;':''"> {{ item }}</div>
               </div>
			</div> 
		</div>
        <img src="../assets/images/48.png" class="img1" @click="next" style="transform: rotate(180deg);" />
    </div>  
       
</template>

<script>
var timedd
export default {
    props:{
        arealist:{
            type: Array,
             default: []
        }
    },
    data() {
        return {
            index:0,
            lefttt:0, //110
            timetype:false,
            list:[],
            timedd:''
        };
    },
  
    created() {
        const that = this;
       
    },
    methods: {
        chong(){
            const that = this
            that.lefttt = 0
            that.index = 0
            that.timetype = false
            clearInterval(timedd)
            console.log("cccccccccccccccccccccccccc:",that.index)
            that.$emit('indexChang',that.index);
        },
        indexchange(index){
            const that = this
            that.index = index
            if(that.index>5){
                if(that.index<that.arealist.length-6){
                    that.lefttt = (that.index - 5)*110
                }else{
                   
                    that.lefttt = ( that.arealist.length  - 9 )*110
                }
                 
            }else{
                that.lefttt = 0
            }
            console.log(that.index,'传index')
            that.$emit('indexChang',that.index);
        },
        timechang(){
            const that = this
            // that.index = 0
            // that.lefttt = 0
            // that.$emit('indexChang',that.index);
            that.timetype = !that.timetype
            if(that.timetype){
                clearInterval(timedd)
                timedd =   setInterval(()=>{
                    that.next()
                },3000)
            }else{
                clearInterval(timedd)
            }
        },
        next(){
        const that = this
       
        if(that.index<that.arealist.length-1){
            that.index++
            if(that.index>5){
                if(that.index<that.arealist.length-6){
                    that.lefttt = (that.index - 5)*110
                }else{
                   
                    that.lefttt = ( that.arealist.length  - 9 )*110
                }
                 
            }else{
                that.lefttt = 0
            }
         if(that.index==that.arealist.length-1){
            that.timetype = false
             clearInterval(that.timedd)
         }
      }
      that.$emit('indexChang',that.index);
     },
     left(){
        const that = this

        if(that.index>0){
        that.index--

        if(that.index>5){
                if(that.index<that.arealist.length-6){
                    that.lefttt = (that.index - 5)*110
                }else{
                   
                    that.lefttt = ( that.arealist.length  - 9 )*110
                }
                 
            }else{
                that.lefttt = 0
            }
        that.$emit('indexChang',that.index);
    }
     }
     },
    
    
};
</script>


<style lang="scss" scoped>
.img{
        width: 26px;
	    height: 26px;
        object-fit: cover;
        margin-right: 10px;
        cursor: pointer;
    }
    .img1{
        width: 22px;
	    height: 22px;
        object-fit: cover;
        cursor: pointer;
        margin-top: 5px;
    }
.box{
    
.img1{
        width: 22px;
	    height: 22px;
        object-fit: cover;
        cursor: pointer;
     
    }
}
.box1{
    display: flex;
    align-items: center;
    // min-width: 600px;
    overflow: hidden;
    flex: 1;
    // justify-content: center;
    // padding: 0 20px;
    margin-top: 8px;
    .box1_cent{
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;
        padding: 0 70px;
        transition: 1s;
        cursor: pointer;
        position: relative;
        .box1_cent_tt1{
            width: 16px;
            height: 16px;
            // background-color: #9ac3f0;
			background-color: #c1c1c1;
            border-radius: 50%;
            z-index: 99;
        }
        .box1_cent_tt{
            font-size: 14px;
            color: #acc0d6;
            margin-top: 5px;
            // white-space: nowrap;
            width:80px;
            text-align: center;

        }
        .sty{
           // background-color: #c1c1c1;
            // box-shadow: 0px 1px 16px 0px 
            //     rgba(22, 93, 173, 0.5);
			background-color: #ffffff;
			border: solid 4px #045bd0;
        }
             
    }
    .box1_cent::after{
        position: absolute;
        content: '';
        width: 100%;
        height: 1px;
        // background-color: #9ac3f0; 
		background-color: #c1c1c1;
        top: 8px;
        left: 50%;
    }
    .box1_cent:last-child::after{
        height: 0;
    }
    
}
@media (max-width:1400px){ 
    .box1_cent{
        padding: 0 10px !important;
    }
}
</style>



// WEBPACK FOOTER //
// timechang.vue?9bf8aa3e